export const SELECT_INFINITY_PAGINATION_ITEMS_ON_PAGE = 10;
export const SELECT_LIST_EMPTY_TEXT_HIDE_CLASS_NAME = 'hide-select-empty-text';
